import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles({
  singleForm: {
    height: '5.25rem',
    backgroundColor: '#fff',
    margin: '1rem 0 0 0 '
  },
  policyBox: {
    width: '100%'
  },
  coloredBox: {
    maxWidth: '2.625rem',
    height: '100%'
  },
  icon: {
    width: '2rem',
    height: '2rem',
    transition: '0.3s',
    margin: '0 1rem',
    cursor: 'pointer'
  },
  dropdownContent: {
    marginTop: '0.5rem'
  }
});

interface PolicyBoxProps {
  boxColor: string;
  children?: any;
  dropdownComponent?: any;
  dropdownContent?: any;
}

const PolicyBox = ({
  boxColor,
  children,
  dropdownComponent,
  dropdownContent
}: PolicyBoxProps) => {
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  const classes = useStyles();
  return (
    <div className={classes.policyBox}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        className={classes.singleForm}
      >
        <Grid
          item
          xs={1}
          className={classes.coloredBox}
          style={{ backgroundColor: boxColor }}
        ></Grid>
        {children}
        <Grid item>
          {dropdownComponent ? (
            dropdownComponent
          ) : (
            <ExpandMoreIcon
              onClick={() => setIsOpenDropdown(!isOpenDropdown)}
              style={{ transform: isOpenDropdown ? 'rotate(180deg)' : 'none' }}
              className={classes.icon}
            />
          )}
        </Grid>
      </Grid>
      {isOpenDropdown && (
        <Grid container spacing={1} className={classes.dropdownContent}>
          <Grid item xs={12}>
            {dropdownContent}
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default PolicyBox;
